import React from 'react';

function Initials(props) {
  let a = !!props.name ? props.name.charAt(0).toUpperCase() : '';
  let b = !!props.surname ? props.surname.charAt(0).toUpperCase() : '';
  const initials = a + b;

  return (
    <div className="profile-initials">
      {initials}
    </div>
  );
}

export default Initials;
